import { Component, Input } from "@angular/core"

@Component({
    selector: "app-facebook-share",
    templateUrl: "./facebook-share.component.html",
    styleUrls: ["./facebook-share.component.scss"],
})
export class FacebookShareComponent {
    @Input() url = location.href

    public share() {
        window.open(
            `https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=${this.url}&display=popup&ref=plugin&src=share_button`,
            "facebook-share-dialog",
            "width=600,height=400"
        )
        return false
    }
}
